import { render, staticRenderFns } from "./_debitCredit.vue?vue&type=template&id=720144f2&scoped=true&"
import script from "./_debitCredit.vue?vue&type=script&lang=js&"
export * from "./_debitCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720144f2",
  null
  
)

export default component.exports